import {
  ExactMatchColumnsForFiltersForDTO,
  RangeColumnsForFiltersForDTO,
} from "@/api/molecularData";

export interface IExactMatchFieldConfig {
  label: string;
  placeholder: string;
  description?: string;
}

export const EXACT_MATCH_FIELD_CONFIG: Record<
  ExactMatchColumnsForFiltersForDTO,
  IExactMatchFieldConfig
> = {
  [ExactMatchColumnsForFiltersForDTO.BSADB_ID]: {
    label: "BSA-DB ID",
    placeholder: "e.g. BSADB_185 or 185",
  },
  [ExactMatchColumnsForFiltersForDTO.CHEMBL_ID]: {
    label: "ChEMBL ID",
    placeholder: "e.g. CHEMBL1455993 or 1455993",
  },
  [ExactMatchColumnsForFiltersForDTO.PUBCHEM_ID]: {
    label: "PubChem ID",
    placeholder: "e.g. 2877277",
  },
  [ExactMatchColumnsForFiltersForDTO.BINDINGDB_ID]: {
    label: "BindingDB ID",
    placeholder: "e.g. 50269835",
  },
  [ExactMatchColumnsForFiltersForDTO.SMILES]: {
    label: "SMILES",
    placeholder: "Exact SMILES string",
    description: "Exact string match — no substructure search.",
  },
};

export interface IRangeFieldConfig {
  label: string;
  step: number;
}

export const RANGE_FIELD_CONFIG: Record<
  RangeColumnsForFiltersForDTO,
  IRangeFieldConfig
> = {
  [RangeColumnsForFiltersForDTO.CALCULATED_MW]: {
    label: "Calculated MW",
    step: 1,
  },
  [RangeColumnsForFiltersForDTO.CALCULATED_LOG_P]: {
    label: "Calculated logP",
    step: 0.1,
  },
  [RangeColumnsForFiltersForDTO.CALCULATED_TPSA]: {
    label: "Calculated TPSA",
    step: 1,
  },
  [RangeColumnsForFiltersForDTO.QED]: {
    label: "QED",
    step: 0.01,
  },
  [RangeColumnsForFiltersForDTO.SA_SCORE]: {
    label: "SA Score",
    step: 0.1,
  },
  [RangeColumnsForFiltersForDTO.CLUSTER_ID]: {
    label: "Cluster ID",
    step: 1,
  },
  [RangeColumnsForFiltersForDTO.HADES_SCORE]: {
    label: "HADES Score",
    step: 0.01,
  },
};

export const RANGE_FIELD_ORDER: RangeColumnsForFiltersForDTO[] = [
  RangeColumnsForFiltersForDTO.CALCULATED_MW,
  RangeColumnsForFiltersForDTO.CALCULATED_LOG_P,
  RangeColumnsForFiltersForDTO.CALCULATED_TPSA,
  RangeColumnsForFiltersForDTO.QED,
  RangeColumnsForFiltersForDTO.SA_SCORE,
  RangeColumnsForFiltersForDTO.CLUSTER_ID,
  RangeColumnsForFiltersForDTO.HADES_SCORE,
];

/** Decimal places to display for a range field, derived from its step. */
export function decimalsForStep(step: number): number {
  return (step.toString().split(".")[1] || "").length;
}

export function formatRangeValue(
  value: number,
  field: RangeColumnsForFiltersForDTO,
): string {
  return value.toFixed(decimalsForStep(RANGE_FIELD_CONFIG[field].step));
}
